// @flow
import React from 'react';
import ErrorInfo from 'components/etc/ErrorInfo/ErrorInfo';
import { Helmet } from 'react-helmet';
import RespStatus from 'components/etc/RespStatus';

const Forbidden = () => {
  return (
    <RespStatus code={403}>
      <Helmet>
        <title>Oops!</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <ErrorInfo code="403" message="해당 페이지에 접근 권한이 없습니다." />
    </RespStatus>
  );
};

export default Forbidden;



// WEBPACK FOOTER //
// ./src/pages/errors/Forbidden.js